import React, { useState, useEffect, Suspense } from 'react'; // Suspense ensures that lazy-loaded components render correctly. lazy components come from ./routes
import { Route, Routes, Link } from 'react-router-dom';
import routes from "./routes";
import ServitechLogoColor from './svg/ServiTechColor.svg'
import { ApiUtils } from 'utils';
import { useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'
import LoginComponent from './LoginComponent';

const AppWrapper = () => {

    const [userEmail, setUserEmail] = useState("");
    const [userToken, setUserToken] = useState("");
    const [userVerified, setUserVerified] = useState(false);
    const [userAccessDenied, setUserAccessDenied] = useState(false)
    const [loginLoading, setLoginLoading] = useState(false)

    const [user, setUser] = useState({
        name: '',
        id: null,
        division: null,
        isManager: false,
        managerName: '',
        managerID: null,
        assetAccess: false,
        email: ''
    })

    const navigate = useNavigate()

    const handleLogOut = async (e) => {
        if (e) {
            e.preventDefault()
        }
        clearEmailToken()
        clearAccessToken()
        setUserVerified(false)
    }

    const getAssetAccessForUser = async (email) => {
        try {
            if (email) {
               const getAssetAccessQuery = `
                    query GetAccessByEmail($Service: String!, $Email_VC: String!) {
                        getAccessByEmail(Service: $Service, Email_VC: $Email_VC) {
                            AssetAccess_BT
                        }
                    }
                `;
                const assetAccessVars = {
                    Service: "Assets",
                    Email_VC: email
                };

                const access = await ApiUtils.gqlQueryWithVars('getAccessByEmail', getAssetAccessQuery, assetAccessVars)
                return access?.AssetAccess_BT || false
            }
            else return false;
        } catch (error) { console.log(error); return false }
    }

    const getEmail = () => {
        const email = localStorage.getItem('email');
        return (email);
    }
    const setEmail = (email) => {
        localStorage.setItem('email', email);
        setUserEmail(email);
    }

    const clearEmailToken = () => {
        localStorage.removeItem('email');
        setUserEmail("");
    }

    const getAccessToken = () => {
        const token = localStorage.getItem('token');
        return (token);
    }
    const setAccessToken = (token) => {
        localStorage.setItem('token', token);
    }

    const clearAccessToken = () => {
        localStorage.removeItem('token');
        setUserToken("")
    }

    const handleGetDivision = async () => {
        if (userEmail) {
            const getInfoFromEmailQuery = `
                query GetPersonByEmail($Email_VC: String!) {
                    getPersonByEmail(Email_VC: $Email_VC) {
                        Division_ID
                        AssetAccess_BT
                        People_ID
                        FirstName_VC
                        LastName_VC
                        IsManager_BT
                        MFirstName_VC
                        MLastName_VC
                        MPeople_ID
                    }
                }
            `;
            const personInfoVars = {
                Email_VC: userEmail
            };

            const personInfo = await ApiUtils.gqlQueryWithVars('getPersonByEmail', getInfoFromEmailQuery, personInfoVars)
            // console.log('my person', personInfo)

            if (personInfo) {
                const dbUser = {
                    name: `${personInfo.LastName_VC}, ${personInfo.FirstName_VC}`,
                    id: personInfo.People_ID,
                    division: personInfo.Division_ID,
                    isManager: personInfo.IsManager_BT,
                    managerName: `${personInfo.MLastName_VC}, ${personInfo.MFirstName_VC}`,
                    managerID: personInfo.MPeople_ID,
                    assetAccess: personInfo.AssetAccess_BT,
                    email: userEmail
                }
                // console.log('my user', dbUser)
                setUser(dbUser)
                setUserVerified(dbUser.assetAccess)
                setLoginLoading(false)
                if (!dbUser.assetAccess) {
                    setUserAccessDenied(true)
                    handleLogOut()
                }
            }
        }
    }

    const email = getEmail();
    const token = getAccessToken();
    // handleGetDivision();

    useEffect(() => {
        if (token) {
            setUserToken(token);
        }
    }, [token]);

    useEffect(() => {
        if (email) {
            setUserEmail(email);
        }
    }, [email]);

    useEffect(() => {
        handleGetDivision()
    }, [userEmail])

    return (
        <div style={{ height: "100vh" }}>
            <nav className="navbar ST-navbar fixed-top">
                <div className="container-fluid">
                    <div>
                        {/* eslint-disable-next-line */}
                        <a className="navbar-brand me-0" href="#"><img src={ServitechLogoColor} height="35px" /></a>
                    </div>
                    <div className="service-title">Asset Manager</div>
                    <div className="pe-0 menu-right-icons">
                        {user?.isManager &&
                            <i className="bi bi-database-gear" title="Manage Data" style={{ "fontSize": "1.5rem", "color": "#000000", "cursor": "pointer" }}
                                onClick={() => navigate('/manageData')} />
                        }
                        {/* eslint-disable-next-line */}
                        <a className="navbar-nav" data-bs-toggle="dropdown">
                            <i className="bi bi-three-dots" style={{ "fontSize": "1.5rem", "color": "#000000", "cursor": "pointer" }}></i>
                        </a>
                        <ul className="me-0 dropdown-menu dropdown-menu-end">

                            <li><a className="dropdown-item" href="https://employee-directory-bjudfyf5za-uc.a.run.app/">Employee Directory</a></li>
                            <li><a className="dropdown-item" href="https://cropfile.servitech.com">The Crop File</a></li>
                            <li><a className="dropdown-item" href="https://labreports.servitechlabs.com/">Lab Reports</a></li>
                            <li><a className="dropdown-item" href="https://intranet.servitech.com">ServiTech Intranet</a></li>

                            <li><hr className="dropdown-divider" /></li>

                            <li className="dropdown-item" onClick={(e) => { handleLogOut(e); setUserAccessDenied(false) }}><Link to="/login" style={{ color: "black", textDecoration: "none" }}>Logout</Link></li>

                        </ul>
                    </div>
                </div>
            </nav >
            <div className="content-routes">
                <Suspense fallback={<div>Loading...</div>}> {/* <-- this line prevents React from throwing an error while waiting for the import to resolve. */}
                    <Routes>
                        {routes.map(({ path, component: Component }) =>
                        (
                            <Route key={path} path={path} element={(userEmail && userToken && userVerified) ? <Component
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                user={user}
                                setUserAccessDenied={setUserAccessDenied}
                                getAssetAccessForUser={getAssetAccessForUser}
                                handleLogOut={handleLogOut}
                            /> : <LoginComponent
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                userAccessDenied={userAccessDenied}
                                getAssetAccessForUser={getAssetAccessForUser}
                                setUserAccessDenied={setUserAccessDenied}
                                setLoginLoading={setLoginLoading}
                                loginLoading={loginLoading}
                            />} />
                        )
                        )}
                    </Routes>
                </Suspense>
            </div>
        </div >
    );
}

export default AppWrapper;
